import { Link } from 'react-router-dom'

export default function AppBrand({ compact = false }: { compact?: boolean }) {
  return <Link to="/" className="inline-flex items-center gap-2 rounded-lg focus:outline-none focus:ring-2 focus:ring-emerald-500" aria-label="Golf App home">
    <img src="/golf-pin.svg" alt="" className={compact ? 'h-9 w-9' : 'h-11 w-11'} />
    <span className="leading-tight"><strong className="block text-lg text-gray-950 dark:text-white">Golf App</strong>{!compact && <span className="block text-xs text-gray-500 dark:text-gray-300">Scorecards · course maps</span>}</span>
  </Link>
}
